

(($, Drupal, once) => {
  Drupal.behaviors.VideoCopy = {
    attach(context) {
      const elements = once('js-video-container-processed', '.js-video-container', context);
      $(elements)
        .each(() => {
          const videoContainers = document.querySelectorAll('.js-video-container');
          if (videoContainers.length > 0) {
            videoContainers.forEach((element) => {
              const video = element.querySelector('video');
              const playButton = element.querySelector('.button-video-play');

              const videoThumbnail = element.querySelector('.video-thumbnail');

              if (video) {
                playButton.addEventListener('click', () => {
                  if (!video.paused) {
                    video.pause();
                  } else {
                    if (videoThumbnail) videoThumbnail.style.display = 'none';
                    video.play();
                  }
                });

                video.addEventListener('playing', () => {
                  playButton.style.visibility = 'hidden';
                });

                video.addEventListener('pause', () => {
                  playButton.style.visibility = 'visible';
                });

                video.addEventListener('ended', () => {
                  if (videoThumbnail) videoThumbnail.style.display = 'block';
                });
              }
            });
          }
        });
    },
  };
})(jQuery, Drupal, once);
